module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-272.cca1316d.jpg";